import { Chip, Icon } from '@mui/material';
import React from 'react';
import { WithTranslationProps } from 'react-i18next';

import { Translate } from './translate';
import { SeamStatus } from '../constants/seam-status';

interface RequestStatusProps extends WithTranslationProps {
    status: SeamStatus;
}

export class RequestStatus extends React.Component<RequestStatusProps> {
    public render(): React.ReactNode {
        return (
            <Chip
                size='small'
                icon={<Icon fontSize='small'>{this.getChipIcon()}</Icon>}
                label={<Translate tkey={`forms:${this.props.status}`} />}
            />
        );
    }

    private getChipIcon() {
        // todo more cases for other statuses
        switch (this.props.status) {
            case SeamStatus.ASSIGN:
                return 'assignment_ind';
            case SeamStatus.TUNE:
                return 'cached';
            case SeamStatus.LABEL:
                return 'cached';
            case SeamStatus.REVIEW:
            case SeamStatus.TXN_CHECK:
                return 'grading';

            case SeamStatus.MIDMATCHING:
                return 'category';
            case SeamStatus.PREPROD:
                return 'publish';
            case SeamStatus.PROD_QA:
            case SeamStatus.QA:
                return 'done_all';
            case SeamStatus.PROD:
                return 'publish';
            case SeamStatus.CLOSED:
                return 'done';
            case SeamStatus.CANCELLED:
                return 'done';
            default:
                return 'cancel';
        }
    }
}
